import { render } from "./ListadoAgrupacionesProfesiones.vue?vue&type=template&id=b4e5f1f2&scoped=true&ts=true"
import script from "./ListadoAgrupacionesProfesiones.vue?vue&type=script&lang=ts"
export * from "./ListadoAgrupacionesProfesiones.vue?vue&type=script&lang=ts"

import "./ListadoAgrupacionesProfesiones.vue?vue&type=style&index=0&id=b4e5f1f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e5f1f2"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTd,QPagination});
